export default ".bold {\n  font-family: \"probold\";\n}";